/**
 * Mobile sticky ATC bar.
 *  - Watches the main buy_buttons block; shows the bottom bar when the main
 *    ATC scrolls out of view.
 *  - When tapped, syncs the chosen variant into the main product form and
 *    submits it, so cart behavior (ajax cart drawer, line item properties,
 *    Shop integrations) is identical to the main flow.
 */
(function () {
  if (window.matchMedia('(min-width: 768px)').matches) return;

  const bar = document.querySelector('[data-pdp-mobile-atc]');
  if (!bar) return;

  const mainBuy =
    document.querySelector('.product-single__box__block--buy_buttons') ||
    document.querySelector('.product-form__cart-submit') ||
    document.querySelector('[name="add"]');
  if (!mainBuy) return;

  const variantSelect = bar.querySelector('[data-pdp-mobile-atc-variant]');
  const submitBtn = bar.querySelector('[data-pdp-mobile-atc-submit]');
  const label = bar.querySelector('[data-pdp-mobile-atc-label]');
  const formId = submitBtn.getAttribute('data-form-id');
  const form = document.getElementById(formId);

  if (!form) {
    console.warn('[pdp-mobile-atc] product form not found:', formId);
    return;
  }

  // ----- visibility -----
  const observer = new IntersectionObserver(
    function (entries) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.inert = true;
      } else {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        bar.inert = false;
      }
    },
    { threshold: 0.05 }
  );
  observer.observe(mainBuy);

  // ----- variant sync from main form into bar -----
  function getMainSelectedVariantId() {
    const id =
      form.querySelector('[name="id"]:checked') ||
      form.querySelector('select[name="id"]') ||
      form.querySelector('input[name="id"]');
    return id ? id.value : null;
  }

  function updateLabel() {
    if (!variantSelect) return;
    const opt = variantSelect.options[variantSelect.selectedIndex];
    if (!opt) return;
    if (opt.disabled) {
      label.textContent = 'Sold out';
      submitBtn.disabled = true;
    } else {
      submitBtn.disabled = false;
      label.textContent = opt.dataset.price ? 'Add — ' + opt.dataset.price : 'Add to cart';
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const opt = variantSelect.options[variantSelect.selectedIndex];
      const scope = form.closest('section') || document;
      const picker = scope.querySelector('variant-radios, variant-selects, variant-mixed-inputs');
      if (picker && opt) {
        const names = JSON.parse(bar.dataset.optionNames || '[]');
        const values = JSON.parse(opt.dataset.options || '[]');
        picker.querySelectorAll('input[type="radio"], select').forEach(function (control) {
          const name = control.name.replace(/^options\[(.*)\]$/, '$1');
          const index = names.indexOf(name);
          if (index < 0) return;
          if (control.tagName === 'SELECT') control.value = values[index];
          else control.checked = control.value === values[index];
        });
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const idInput = form.querySelector('select[name="id"], input[name="id"]');
        if (idInput) {
          idInput.value = variantSelect.value;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      updateLabel();
    });
    updateLabel();
  }

  // Keep bar in sync if user picks variant via main swatches/buttons
  form.addEventListener('change', function () {
    if (!variantSelect) return;
    const mainId = getMainSelectedVariantId();
    if (mainId && mainId !== variantSelect.value) {
      variantSelect.value = mainId;
      updateLabel();
    }
  });

  // ----- submit -----
  submitBtn.addEventListener('click', function () {
    // Never submit a different variant than the sticky control displays.
    if (variantSelect && getMainSelectedVariantId() !== variantSelect.value) {
      label.textContent = 'Choose options';
      mainBuy.scrollIntoView({ block: 'center' });
      return;
    }
    // Prefer the existing ATC button so the theme's ajax-cart handler runs.
    const mainAtc =
      form.querySelector('.product-form__cart-submit') ||
      form.querySelector('[name="add"]');
    if (mainAtc) {
      mainAtc.click();
    } else {
      form.requestSubmit();
    }
  });
})();
